// Download do Excel de UM orçamento já salvo, sem abrir nem salvar o orçamento.
//
// Mesmo endpoint e mesmo corpo do "Baixar Excel" de dentro do orçamento
// (CadastroOrcamento → POST /orcamento/gerarPlanilhaExcel com
// `{ data: JSON.stringify({ token, rows: [id] }) }`). O modelo da planilha
// (Chiesi, AbbVie, Sanofi, Master…) é escolhido pela API a partir do cliente do
// evento (`OrcamentoMultipleExport::resolverModeloExport`); o nome do arquivo
// vem do `Content-Disposition` (exposto no CORS da API).
//
// Caso 14 do QA de 25/09: o menu ⋮ do painel submetia um <form target="_blank">
// — a requisição saía numa aba nova (o DevTools da aba do painel não via nada),
// dependia de popup liberado e, se falhasse, não havia aviso nenhum.

import { ehClienteAllergan } from './allerganFeePolicy';

export const TIPO_XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export function nomeArquivoExcelOrcamento(contentDisposition, orcamentoId) {
    const cabecalho = contentDisposition || '';
    const utf8 = cabecalho.match(/filename\*\s*=\s*UTF-8''([^;\n]+)/i);
    if (utf8) {
        try { return decodeURIComponent(utf8[1].trim()); } catch (e) { /* cai no filename= */ }
    }
    const simples = cabecalho.match(/filename\s*=\s*("([^"]*)"|'([^']*)'|[^;\n]*)/i);
    const nome = simples ? (simples[2] ?? simples[3] ?? simples[1]).replace(/['"]/g, '').trim() : '';
    return nome || `Orcamento-${orcamentoId}.xlsx`;
}

// Busca o xlsx. Resolve `{ blob, nomeArquivo }` ou rejeita com Error de mensagem
// legível — inclusive quando a API responde 200 com JSON ("Acesso Negado").
export async function buscarExcelOrcamento({ apiUrl, token, orcamentoId, orcamentoIds, fetchImpl }) {
    const fazerFetch = fetchImpl || fetch;
    const resposta = await fazerFetch(`${apiUrl}/orcamento/gerarPlanilhaExcel`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: TIPO_XLSX,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data: JSON.stringify({ token, rows: (orcamentoIds || [orcamentoId]).map(String) }) }),
    });

    const tipo = (resposta.headers.get('content-type') || '').toLowerCase();
    if (!resposta.ok || !tipo.includes('spreadsheetml')) {
        let detalhe = '';
        try {
            const texto = await resposta.text();
            try {
                const json = JSON.parse(texto);
                detalhe = json?.data?.mensagem || json?.error || json?.message || '';
            } catch (e) {
                detalhe = '';
            }
        } catch (e) { /* sem corpo */ }
        throw new Error(detalhe || `Falha ao gerar o Excel (HTTP ${resposta.status}).`);
    }

    const blob = await resposta.blob();
    if (!blob || !blob.size) throw new Error('A API devolveu um Excel vazio.');
    return { blob, nomeArquivo: nomeArquivoExcelOrcamento(resposta.headers.get('content-disposition'), orcamentoId) };
}

// Allergan (D-0152): orçamentos em Real de evento nacional saem juntos num Excel só (uma coluna no Resumo
// Comparativo e uma aba por orçamento). O resto sairia como aba Master no mesmo arquivo: não entra na seleção.
// Espelho de OrcamentoAllerganExport::aplicavel, sem a linha no exterior, que a lista do painel não traz.
export function orcamentoEntraNoExcelAllergan(row) {
    if (!ehClienteAllergan(row?.evento?.cliente)) return false;
    const moeda = String(row?.moeda ?? 'real').toLowerCase();
    const nacionalidade = String(row?.evento?.nacionalidade ?? 'nacional').toLowerCase();
    return (moeda === 'real' || moeda === '') && nacionalidade !== 'internacional';
}

// Ordem das colunas e do nome do arquivo: número do orçamento.
export function idsExcelAllergan(rows) {
    return [...rows]
        .sort((a, b) => Number(a?.codigo ?? 0) - Number(b?.codigo ?? 0))
        .map((row) => String(row.id));
}

export function salvarBlobComoArquivo(blob, nomeArquivo) {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = nomeArquivo;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // Revoga depois do clique ser processado (revogar na hora cancela o download em alguns navegadores).
    setTimeout(() => window.URL.revokeObjectURL(url), 1000);
}
